export default __webpack_public_path__ + "static/media/sklo.53a9e1ef.svg";